'use client'

import styled, {css} from 'styled-components'

import theme, {media} from '@/src/config/theme'

export const Pagination = styled.div`
  justify-content: flex-end;

  &.ant-pagination {
    align-items: center;
    justify-content: flex-end;

    .ant-pagination-item {
      line-height: 1;
      align-items: center;
      display: flex;
      justify-content: center;

      border: unset;
      min-width: unset;
      width: 33px;
      height: 33px;
      border-radius: 50%;

      // color: ${theme.colors.textDark};

      a {
        width: 33px;
        height: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      a,
      &:hover a {
        color: inherit;
      }
    }

    .ant-pagination-item-active {
      color: ${theme.colors.text};
      background-color: ${theme.colors.primary};

      & > * {
        &:after {
        }
      }
    }

    .ant-pagination-jump-next,
    .ant-pagination-jump-prev,
      // + li это "перейти к последнему элементу"
    .ant-pagination-jump-next + li {
      display: none;
    }

    .ant-pagination-next,
    .ant-pagination-prev {
      // color: ${theme.colors.white};
      display: flex;
      align-items: center;

      svg {
        //fill: ${theme.colors.white};
      }

      &.ant-pagination-disabled {
        svg {
          fill: ${theme.colors.gray};
        }
      }

      .ant-pagination-item-link {
        height: 100%;
        border-radius: 50%;
      }
    }

    .ant-pagination-item-link {
      height: 1rem;

      [disabled] {
        color: ${theme.colors.gray};
      }
    }
  }

  @media ${media.md} {
    padding-top: unset;
    justify-content: flex-end;
  }
`

export const PerPageOptions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  font-weight: 450;
`

export const PerPage = styled.div<{$active?: boolean}>`
  transition: background ease 0.3s;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  width: 33px;
  height: 33px;

  border-radius: 50%;

  &:hover {
    background: ${theme.colors.grayHover};
  }

  &:active {
    background: ${theme.colors.grayActive};
  }

  ${props =>
    (props.$active &&
      css`
        cursor: unset;
        background: ${theme.colors.primary};

        &:hover,
        &:active {
          background: ${theme.colors.primary};
        }
      `) ||
    css`
      span {
        text-decoration: underline;
        text-decoration-style: dotted;
        text-underline-offset: 3px;
      }
    `}
`
